import React, { Children } from 'react';
import { Box, Typography } from '@mui/material';
import { CHATBOT, blastMainStyles, questionPrompts } from '../ask-blast-helper';
import { Avatar } from '@biq/apex-ui';

interface WelcomeMessageProps {
    userPrompt: string;
    handleQuestionPromptClick: (question: string) => void;
}

export const WelcomeMessage = ({
    userPrompt,
    handleQuestionPromptClick,
}: WelcomeMessageProps): React.JSX.Element => {
    return (
        <>
            <Typography sx={blastMainStyles.initialChatTitleText}>
                {CHATBOT.INITIAL_CHAT_TITLE}
            </Typography>
            <Typography sx={blastMainStyles.initialChatDescriptionText}>
                {CHATBOT.INITIAL_CHAT_DESCRIPTION}
            </Typography>
            {!userPrompt && (
                <Box sx={blastMainStyles.questionPromptMainContainerStyles}>
                    {Children.toArray(
                        questionPrompts.map((prompt: string) => {
                            return (
                                <Box
                                    sx={
                                        blastMainStyles.questionPromptContainerStyles
                                    }
                                    onClick={(): void =>
                                        handleQuestionPromptClick(prompt)
                                    }
                                >
                                    <Avatar initial={'Q'} sizes={'large'} />
                                    <Typography
                                        sx={
                                            blastMainStyles.questionPromptTextStyles
                                        }
                                    >
                                        {prompt}
                                    </Typography>
                                </Box>
                            );
                        })
                    )}
                </Box>
            )}
        </>
    );
};
